import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=6f400a7b&scoped=true"
import script from "./PlanList.vue?vue&type=script&lang=js"
export * from "./PlanList.vue?vue&type=script&lang=js"
import style0 from "./PlanList.vue?vue&type=style&index=0&id=6f400a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f400a7b",
  null
  
)

export default component.exports